export default "__VITE_ASSET__BQE1OxSB__"